import {
  Divider,
  DottedLine,
} from '@droplet-tech-code/core-elements/module/ui/Divider/Divider';
import { useModal } from '@droplet-tech-code/core-elements/module/ui/Modal';
import { VStack } from '@droplet-tech-code/core-elements/module/ui/Stack';
import { RouteTripNoDetails } from '@naus-code/naus-client-types';
import { useRef } from 'react';

import { ManualRequestedTrip, OriginalRequestedTrip } from '../ Modify.SelectedTrip';
import { SearchPanelQuery } from '../Modify.Search';
import { ModifyBasketPanelQuery } from '../Modify.Tickets';
import { ModifyPanelProps, useModifyData } from '../Modify.utils';

export const ApiTripManager = (props: ModifyPanelProps) => {
  const selectRouteRef = useRef<RouteTripNoDetails | undefined>();

  const { openModal } = useModal();
  const { purchase } = useModifyData(props);
  const openSearchPanel = (purchase) => {
    openModal(
      <SearchPanelQuery {...props} selectRouteRef={selectRouteRef} purchase={purchase} />,
      { key: 'searchTripQuery' },
    );
  };

  return (
    <VStack pt="5">
      <VStack space="5">
        <Divider />
        <VStack space="3">
          <OriginalRequestedTrip {...props} onEdit={() => openSearchPanel(purchase)} />
          <ManualRequestedTrip
            {...props}
            selectRouteRef={selectRouteRef}
            onEdit={() => openSearchPanel(purchase)}
          />
        </VStack>
        <DottedLine />
        <ModifyBasketPanelQuery {...props} />
      </VStack>
    </VStack>
  );
};
